<template>
  <v-container class="step">
    <v-row justify="center" class="full-height">
      <v-col class="s3-container">
          <div xs="6" sm="6" md="7" class="s3-left"
              data-aos="fade-right"
              data-aos-delay="0"
              data-aos-duration="2000"
              data-aos-mirror="true"
              data-aos-once="false"
            >
              <div class="s3-txt">
                <p>
                  {{$t("_s3_txt_1")}}
                </p>
                <p>
                  {{$t("_s3_txt_2")}}
                </p>
                <p>
                  {{$t("_s3_txt_3")}}
                </p>
              </div>
            </div>
            <div xs="6" sm="6" md="5" class="s3-right">
              <div class="image-container">
                <img
                alt="renb renb.jp 生プラセンタ 化粧品"
                data-aos="fade-left"
                data-aos-delay="0"
                data-aos-duration="2000"
                data-aos-mirror="true"
                data-aos-once="false"
                class="s3-img"
                :src="baseUrl + '/media/image/renb_pic5.png'" />
              </div>
          </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL
    }
  }
}
</script>

<style scoped>
.s3-container {
    width: 100%; /* Chiều rộng của div */
    height: 100%; /* Hoặc có thể là một giá trị cụ thể như 500px */
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}
.s3-left {
  width: 60%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}
.s3-right {
  width: 40%;
  max-height: 80%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.s3-img {
  /* max-height: 500px; */
  object-fit: contain;
  position: relative;
}
.s3-txt {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  height: 500px;
  width: 500px;
  line-height: 2;
}
@media (max-width: 960px) {
  .s3-container {
      align-items: start;
  }
  .step {
    height: unset!important;
    scroll-snap-align:unset;
    margin-top: 20%;
  }
  .full-height {
    height: unset!important;
    width: 100%;
    padding: unset!important;
  }
  .s3-right {
    width: 50%;
  }
  .s3-left {
    width: 49%;
    position: relative;
    display: block;
    position: relative;
    top: 0;
    padding: 0 20px;
  }
  .s3-img {
    /* max-height: 500px; */
    width: 100%;
  }
  .s3-txt {
    height: 100%;
    width: 100%;
    line-height: 2;
    height: 500px;
  }
}
@media (max-width: 600px) {
  .s3-right {
    width: 100%;
  }
  .s3-left {
    width: 100%;
  }
  .s3-container {
    flex-direction: column-reverse;
    padding: unset!important;
  }
  .s3-left {
    padding: 0 10px;
  }
  .image-container {
    width: 100%;
  }
}

</style>